import { useMemo } from "react";
import { useAuth } from "../providers/AuthProvider";
import { useSession } from "../providers/SessionProvider";
import { createExperimentTrackingApi } from "../services/experiments/tracking";
import { getCanonicalAuthUserId } from "../services/authIdentity";

const useExperimentTracking = () => {
  const { currentUser } = useAuth() || {};
  const {
    sessionId = "",
    utmSource = null,
    systemData = null,
    locationData = null,
  } = useSession() || {};
  const currentUserId = getCanonicalAuthUserId(currentUser);

  return useMemo(
    () =>
      createExperimentTrackingApi({
        currentUserId,
        sessionId,
        utmSource,
        systemData,
        locationData,
      }),
    [
      currentUserId,
      sessionId,
      utmSource,
      systemData,
      locationData,
    ],
  );
};

export default useExperimentTracking;
